import React, { useState } from 'react';
import { Button, Card, Descriptions, Divider, Typography, Space, Dropdown } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { CaretDownFilled, EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import objectStore from '../../store/ObjectStore';
import equipmentStore from '../../store/EquipmentStore';
import EquipmentModalForm from '../../components/equipment/EquipmentModalForm';
import dayjs from 'dayjs';

const { Paragraph, Text } = Typography;

export default function EquipmentPage() {
  const { objectId, equipmentId } = useParams();
  const navigate = useNavigate();

  const object = objectStore.getObjectById(objectId);
  const equipment = equipmentStore.getEquipmentById(equipmentId);

  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleSaveEquipment = (updatedEquipment) => {
    equipmentStore.updateEquipment(equipment.id, updatedEquipment);
    setEditModalOpen(false);
  };

  const handleDeleteEquipment = () => {
    equipmentStore.deleteEquipment(equipment.id);
    navigate(`/objects/${objectId}`);
  };

  if (!equipment) return <div>Оборудование не найдено</div>;

  const data = [
    {
      label: 'Номер',
      children: <Paragraph copyable>{equipment.number || '-'}</Paragraph>,
      span: 'filled',
    },
    {
      label: 'Срок действия до',
      children: <Paragraph copyable>{equipment.dateExpired ? dayjs(equipment.dateExpired).format('DD.MM.YYYY') : '-'}</Paragraph>,
      span: 'filled',
    },
    {
      label: 'Тип оборудования',
      children: <Paragraph copyable>{equipment.type || '-'}</Paragraph>,
      span: 'filled',
    },
  ];

  const items = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: 'Изменить',
      onClick: (e) => {
        e.domEvent.stopPropagation();
        setEditModalOpen(true);
      },
    },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      label: <span style={{ color: 'red' }}>Удалить</span>,
      onClick: (e) => {
        e.domEvent.stopPropagation();
        handleDeleteEquipment();
      },
    },
  ];

  return (
    <>
      <Space split={<Divider type="vertical" />} size='small' style={{ marginBottom: 20 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
        />
            <Button
                      type="text"
          onClick={(e) => { e.stopPropagation(); navigate(`/objects/${objectId}`); }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: 0,
                        maxWidth: 100,
                        minWidth: 0, 
                      }}
                    >
                      <Text
                        ellipsis
                        style={{
                          flex: 1,
                          minWidth: 0,
                          fontWeight: 600,
                          fontSize: 16,
                          marginRight: 6,
                        }}
                      >
                        {object.name}
                      </Text>                      
                    </Button>
        <Dropdown placement="bottomRight" menu={{ items }} trigger={['click']}>
          <Button
                    type="text"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 0,
                      maxWidth: 120,
                      minWidth: 0, 
                    }}
                  >
                    <Text
                      ellipsis
                      style={{
                        flex: 1,
                        minWidth: 0,
                        fontWeight: 600,
                        fontSize: 16,
                        marginRight: 6,
                      }}
                    >
                      {equipment.name}
                    </Text>
                    <CaretDownFilled />
                    
                  </Button>
        </Dropdown>
      </Space>

      <Descriptions style={{ maxWidth: 400 }} bordered items={data} />

      <Divider orientation="left">Связанные файлы</Divider>

      {equipment.bitrixFolderLink && (
        <Button
          type="primary"
          onClick={() => window.open(equipment.bitrixFolderLink, '_blank')}
        >
          Открыть файлы
        </Button>
      )}

      {/* Модалка для редактирования оборудования */}
      <EquipmentModalForm
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        equipment={equipment}
        objectId={objectId}
        onSave={handleSaveEquipment}
      />
    </>
  );
}
